import {
  formatDA,
  formatNumberPrecision,
  formatPN,
  formatTM,
  formatDATM
} from "./format.js";

const Format = {
  formatDA,
  formatNumberPrecision,
  formatPN,
  formatTM,
  formatDATM
};

const DateHelper = {
  Format
};
export default DateHelper;
